import { useEffect, useState } from "react";
import Spinner from "../../feedback/Spinner/Spinner";
import styles from './styles.module.scss';

const Img = ({ src, alt, imgDefault, style = {}, classNameContent, privateImg, variant = 'default', ...props }) => {
	const [loading, setLoading] = useState(true);
	const [hasTriedDefault, setHasTriedDefault] = useState(false);

	const onError = (e) => {
		if (!hasTriedDefault) {
			setHasTriedDefault(true);
			if (imgDefault) {
				e.target.src = imgDefault;
				return;
			};
			e.target.onerror = null;
			setLoading(false);
		} else {
			e.target.onerror = null;
			setLoading(false);
		};
	};

	return (<>
		<div className={`${styles.img} ${styles[variant]} ${classNameContent}`}>
			{(loading || !src) &&
				<Spinner
					position='absolute'
					background='rgba(0, 0, 0, 0)'
					color='blue'
					size='40px'
				/>}
			<img
				onError={onError}
				onLoad={
					() => {
						setLoading(false)
					}
				}
				style={{
					...style,
					display: `${loading ? 'none' : ''}`
				}}
				src={src || imgDefault}
				alt={(loading || !src) ? 'Cargando imagen...' : alt}
				{...props}
			/>
		</div>
	</>);
};

export default Img;